/* eslint-disable */
import { useForm, Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { toastSuccess } from '../utils/toasts';
import { useEffect, useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { CustomerGroupDTO } from '../models/customer';
import Input from './atoms/Input';
import Button from './atoms/Button';
import { useCreateCustomerGroupMutation, useEditCustomerGroupMutation } from '../store';
import Select from './atoms/Select/Select';
import EventDTO from '../models/event';

interface Props {
  customerGroup: CustomerGroupDTO | null;
  onClose: () => void;
  events: EventDTO[];
}

interface FormData {
  name: string;
  events: string[];
}

const ViewEditCustomerGroup = ({ customerGroup, onClose, events }: Props) => {
  const { business_id: businessId } = useParams<{ business_id: string }>();

  const [createCustomerGroup, { isLoading: isCreating, isSuccess: isCreated }] = useCreateCustomerGroupMutation();
  const [editCustomerGroup, { isLoading: isEditing, isSuccess: isEdited }] = useEditCustomerGroupMutation();
  const [selectedEvents, setSelectedEvents] = useState<string[]>([]);

  useEffect(() => {
    if (isCreated) {
      onClose();
      toastSuccess('Grupo creado correctamente');
    }
  }, [isCreated]);

  useEffect(() => {
    if (isEdited) {
      onClose();
      toastSuccess('Grupo editado correctamente');
    }
  }, [isEdited]);

  useEffect(() => {
    if (customerGroup) {
      setSelectedEvents(customerGroup.events.map((e) => e.id));
    }
  }, [customerGroup]);

  const { control, handleSubmit, formState: { errors } } = useForm<FormData>({
    defaultValues: {
      name: customerGroup?.name || '',
      events: selectedEvents,
    },
  });

  const onSubmit = (data: FormData) => {
    if (customerGroup) {
      editCustomerGroup({ businessId: businessId || '', customerGroupId: customerGroup.id, data: {
        name: data.name,
        event_ids: selectedEvents,
      } });
    } else {
      createCustomerGroup({ businessId: businessId || '', data: {
        name: data.name,
        event_ids: selectedEvents,
      } });
    }
  };

  return (
  <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col gap-4'>
    <Controller
      name='name'
      control={control}
      render={({ field }) => (
        <Input
          {...field}
          id='name'
          label='Nombre'
          labelAbove
          errMsg={errors.name?.message}
        />
      )}
    />
    <Controller
      name='events'
      control={control}
      render={({ field }) => (
        <Select
          {...field}
          id='name'
          label='Eventos'
          errMsg={errors.name?.message}
          options={events.filter((event) => !selectedEvents.includes(event.id)).map((event) => ({
            label: event.name,
            value: event.id,
          }))}
          onChange={(e) => {
            setSelectedEvents([...selectedEvents, e.target.value]);
            field.onChange(e.target.value);
          }}
        />
      )}
    />
    <div className='flex flex-row gap-2 flex-wrap mt-2'>
      {selectedEvents.map((event) => (
        <div
          key={event}
          className="p-1 bg-surface-secondary rounded-md border border-border-primary w-fit flex items-center gap-2"
          onClick={() => setSelectedEvents(selectedEvents.filter((se) => se !== event))}>
          {events.find((e) => e.id === event)?.name}
          <IoClose className="h-4 w-4" />
        </div>
      ))}
    </div>
    <div className='flex'>
      <Button type='button' variant='secondary' onClick={onClose}>Cancelar</Button>
      <Button type='submit' variant='primary' loading={isCreating || isEditing}>Guardar</Button>
    </div>
  </form>
  );
};

export default ViewEditCustomerGroup;
